// Type definitions for variation data
interface Variation {
    attributes: {
        pa_size: string;
        pa_colour: string;
    };
    is_in_stock: boolean;
    qty: number;
    is_purchasable: boolean;
    variation_id: number;
}

export default class ProductSwatches {
    constructor() {
        let selectedColor: string | null = null;
        let selectedSize: string | null = null;

        const variationsDataElement = document.getElementById("variations-data");
        const colourName = document.getElementById('colour-swatch__active-colour');

        if (!variationsDataElement) {
            // console.error("Variations data not found!");
            return;
        }

        const variations: Variation[] = JSON.parse(variationsDataElement.textContent || "{}");
        // console.log(variations);

        let hasColour = false;
        let hasSize = false;

        // Check what state we are in.
        variations.forEach((variation: any) => {
            if(variation.attributes['pa_size']) {
                hasSize = true
            }

            if(variation.attributes['pa_colour']) {
                hasColour = true
            }
        });

        // Function to get colors that have no stock in any size
        const getUnavailableColors = (variations: Variation[]): string[] => {
            // Group variations by color
            const colorGroups = variations.reduce((acc, variation) => {
                const color = variation.attributes.pa_colour;
                if (!acc[color]) {
                    acc[color] = [];
                }
                acc[color].push(variation);
                return acc;
            }, {} as Record<string, Variation[]>);

            // Find colors where all variations are out of stock
            const unavailableColors: string[] = [];

            Object.entries(colorGroups).forEach(([color, colorVariations]) => {
                const hasStock = colorVariations.some(variation =>
                    variation.is_in_stock && variation.is_purchasable && variation.qty > 0
                );

                if (!hasStock) {
                    unavailableColors.push(color);
                }
            });

            // console.log('Unavailable colors:', unavailableColors);

            return unavailableColors;
        };

        // Function to remove unavailable color swatches from DOM
        const removeUnavailableColorSwatches = (): void => {
            const unavailableColors = getUnavailableColors(variations);
            const colours = document.querySelectorAll('.colour-swatch__border-wrapper');

            // console.log('Colors being removed (no stock in any size):', unavailableColors);

            colours.forEach(colour => {
                const colorValue = colour.getAttribute('data-value');
                if (colorValue && unavailableColors.includes(colorValue)) {
                    // Remove the element entirely
                    colour.remove();
                    // console.log(`Removed color swatch: ${colorValue}`);
                }
            });

            // Also remove from dropdown options if they exist
            const colourDropdown = document.querySelector('select[name="attribute_pa_colour"]');
            if (colourDropdown) {
                unavailableColors.forEach(color => {
                    const option = colourDropdown.querySelector(`option[value="${color}"]`);
                    if (option) {
                        option.remove();
                        // console.log(`Removed color option from dropdown: ${color}`);
                    }
                });
            }
        };

        // Remove unavailable colors on initialization
        if (hasColour) {
            removeUnavailableColorSwatches();
        }

        // Update the hidden variation ID input
        const updateVariationId = () => {
            const matchedVariation = variations.find((variation: any) => {
                const attributes = variation.attributes;

                return (
                    attributes["pa_size"] === selectedSize &&
                    attributes["pa_colour"] === selectedColor
                );
            });

            if (matchedVariation) {
                (document.querySelector("[name=variation_id]") as HTMLInputElement).value =
                    matchedVariation.variation_id;
            } else {
                (document.querySelector("[name=variation_id]") as HTMLInputElement).value = "";
            }
        };

        const checkStockColourNoSize = () => {
            const colours = document.querySelectorAll('.colour-swatch__border-wrapper');
            const noStockColourArray: string[] = [];

            variations.forEach((colour: any) => {
                if(colour.is_purchasable === false) {
                    noStockColourArray.push(colour.attributes["pa_colour"])
                }
            });

            colours.forEach((colour) => {
                const colourData = colour.getAttribute('data-value');
                if(colourData && noStockColourArray.includes(colourData)) {
                    colour.classList.add('is-not-in-stock');
                }
            })
        }

        const checkStockSizeNoColour = () => {
            const sizes = document.querySelectorAll('.size-swatches__size');
            const noStockSizesArray: string[] = [];

            variations.forEach((size: any) => {
                if(size.is_purchasable === false) {
                    noStockSizesArray.push(size.attributes["pa_size"])
                }
            });

            sizes.forEach((size) => {
                const sizeData = size.getAttribute('data-value');
                if(sizeData && noStockSizesArray.includes(sizeData)) {
                    size.classList.add('is-not-in-stock');
                }
            })
        }

        // Check which variations are in stock
        const checkStock = () => {
            const sizes = document.querySelectorAll('.size-swatches__size');
            const colours = document.querySelectorAll('.colour-swatch__border-wrapper');

            // Reset all swatches
            sizes.forEach(size => size.classList.remove('is-not-in-stock'));
            colours.forEach(colour => colour.classList.remove('is-not-in-stock'));

            // If a colour is selected, check the size dropdown
            if (selectedColor) {
                const sizeDropdown = document.querySelector('select[name="attribute_pa_size"]');
                if (sizeDropdown) {
                    sizes.forEach(size => {
                        const val = size.getAttribute('data-value');
                        const option = sizeDropdown.querySelector(`option[value="${val}"]`);
                        if (option && option.disabled || option === null) {
                            // console.log('size is set to for not in stock: ', option, ' and setting: ', size);
                            size.classList.add('is-not-in-stock');
                        } else {
                            // console.log('size is set to: ', option, ' and setting: ', size);
                        }
                    });
                }
            }

            // If a size is selected, check the colour dropdown
            if (selectedSize) {
                const colourDropdown = document.querySelector('select[name="attribute_pa_colour"]');
                if (colourDropdown) {
                    colours.forEach(colour => {
                        const val = colour.getAttribute('data-value');
                        const option = colourDropdown.querySelector(`option[value="${val}"]`);
                        if (option && option.disabled || option === null) {
                            colour.classList.add('is-not-in-stock');
                        }
                    });
                }
            }

            // console.log(sizesArray)
            // console.log(coloursArray)
            //
            // const findStockColour = variations.filter((variation: any) => {
            //     return variation.attributes["attribute_pa_colour"] === selectedColor;
            // });
            //
            // const findStockSizes = variations.filter((variation: any) => {
            //     return variation.attributes["attribute_pa_size"] === selectedSize;
            // });
            //
            // findStockColour.forEach((colour: any) => {
            //     console.log(colour)
            //     if(colour.is_purchasable === false) {
            //         noStockSizes.push(colour.attributes["attribute_pa_size"]);
            //     }
            // });
            //
            // findStockSizes.forEach((size: any) => {
            //     console.log(size)
            //     if(size.is_purchasable === false || !size.is_purchasable) {
            //         noStockColours.push(size.attributes["attribute_pa_colour"]);
            //     }
            // });
            //
            // sizes.forEach((size) => {
            //     const sizeData = size.getAttribute('data-value');
            //     if(noStockSizes.includes(sizeData)) {
            //         size.classList.add('is-not-in-stock');
            //     }
            // })
            //
            // colours.forEach((colour) => {
            //     const colourData = colour.getAttribute('data-value');
            //     if(noStockColours.includes(colourData)) {
            //         colour.classList.add('is-not-in-stock');
            //     }
            // })
        }

        // Find available size for selected color from variations data
        const findAvailableSizeForColor = (color: string): string | null => {
            const availableVariations = variations.filter((variation: any) =>
                variation.attributes["pa_colour"] === color && variation.is_in_stock
            );

            if (availableVariations.length > 0) {
                // Return the first available size for this color
                return availableVariations[0].attributes["pa_size"];
            }
            return null;
        };

        // NEW: Find available color for selected size from variations data
        const findAvailableColorForSize = (size: string): string | null => {
            const availableVariations = variations.filter((variation: any) =>
                variation.attributes["pa_size"] === size &&
                variation.is_in_stock &&
                variation.is_purchasable &&
                variation.qty > 0
            );

            if (availableVariations.length > 0) {
                // Return the first available color for this size
                return availableVariations[0].attributes["pa_colour"];
            }
            return null;
        };

        // Update WooCommerce dropdowns and trigger events - ACTUALLY FIXED VERSION
        const updateWooCommerceDropdowns = () => {
            if (selectedColor) {
                const colorDropdown = document.querySelector('select[name="attribute_pa_colour"]') as HTMLSelectElement;
                if (colorDropdown) {
                    colorDropdown.value = selectedColor;
                    colorDropdown.dispatchEvent(new Event("change"));
                }
            }

            if (selectedSize) {
                const sizeDropdown = document.querySelector('select[name="attribute_pa_size"]') as HTMLSelectElement;
                if (sizeDropdown) {
                    sizeDropdown.value = selectedSize;
                    sizeDropdown.dispatchEvent(new Event("change"));
                }
            }

            // Trigger WooCommerce variation updates
            const variationForm = jQuery(".variations_form");
            variationForm.trigger("woocommerce_update_variation_values");
            variationForm.trigger("woocommerce_variation_select_change");
            variationForm.trigger("check_variations");
            variationForm.trigger("woocommerce_variation_has_changed");
        };

        // Handle re-clicking swatch
        const removeSelectedColour = () => {
            if (selectedColor) {
                document.querySelectorAll(".colour-swatch__border-wrapper").forEach(colour => {
                    const sizes = document.querySelectorAll('.size-swatches__size');
                    sizes.forEach((size) => {
                        size.classList.remove('is-not-in-stock')
                    })
                    colour.classList.remove('active');

                });
            }
        };

        const removeSelectedSize = () => {
            if (selectedSize) {
                document.querySelectorAll(".size-swatches__size").forEach(size => {
                    const colours = document.querySelectorAll('.colour-swatch__border-wrapper');
                    colours.forEach((colour) => {
                        colour.classList.remove('is-not-in-stock')
                    })
                    size.classList.remove('active');
                });
            }
        };

        // Handle colour swatch click
        document.querySelectorAll(".colour-swatch__border-wrapper").forEach(colour => {
            colour.addEventListener("click", function (this: HTMLElement) {
                // Reset WooCommerce form first
                const resetButton = document.querySelector('.reset_variations') as HTMLAnchorElement;
                if (resetButton) {
                    resetButton.click();
                    // console.log('Reset variations form');
                }

                // Reset our internal state
                selectedSize = null;
                document.querySelectorAll('.size-swatches__size').forEach(size => size.classList.remove('active'));

                removeSelectedColour();
                selectedColor = (this as HTMLElement).getAttribute("data-value");
                const selectedColorTitle = (this as HTMLElement).getAttribute("title");

                this.classList.add('active');

                if(colourName) {
                    colourName.textContent = selectedColorTitle;
                }

                if(hasSize && hasColour) {
                    // console.log('hasSize && hasColour');
                    checkStock();
                } else if(hasSize) {
                    // console.log('hasSize');
                    checkStockSizeNoColour();
                } else if(hasColour) {
                    // console.log('hasColour');
                    checkStockColourNoSize();
                }
                updateVariationId();
                updateWooCommerceDropdowns();

                // Force re-check because the dropdown will have changed again.
                if(hasSize && hasColour) {
                    // console.log('hasSize && hasColour');
                    checkStock();
                } else if(hasSize) {
                    // console.log('hasSize');
                    checkStockSizeNoColour();
                } else if(hasColour) {
                    // console.log('hasColour');
                    checkStockColourNoSize();
                }
            });
        });

        // Add a check to see if the reset button available
        const resetButton = document.querySelector("#colour-swatch__reset-wrapper");
        if(resetButton) {
            resetButton.addEventListener("click", function () {
                // Reset WooCommerce form
                const resetButton = document.querySelector('.reset_variations') as HTMLAnchorElement;
                if (resetButton) {
                    resetButton.click();
                    // console.log('Reset variations form');
                }

                // Reset our internal state
                selectedSize = null;
                document.querySelectorAll('.size-swatches__size').forEach(size => size.classList.remove('active'));

                removeSelectedSize();

                selectedColor = null;
                document.querySelectorAll('.colour-swatch__border-wrapper').forEach(colour => colour.classList.remove('active'));

                removeSelectedColour();

                if(hasSize && hasColour) {
                    // console.log('hasSize && hasColour');
                    checkStock();
                } else if(hasSize) {
                    // console.log('hasSize');
                    checkStockSizeNoColour();
                } else if(hasColour) {
                    // console.log('hasColour');
                    checkStockColourNoSize();
                }
                updateVariationId();
                updateWooCommerceDropdowns();

                // Force re-check because the dropdown will have changed again.
                if(hasSize && hasColour) {
                    // console.log('hasSize && hasColour');
                    checkStock();
                } else if(hasSize) {
                    // console.log('hasSize');
                    checkStockSizeNoColour();
                } else if(hasColour) {
                    // console.log('hasColour');
                    checkStockColourNoSize();
                }
            });
        }

        // Handle size swatch click
        document.querySelectorAll(".size-swatches__size").forEach(size => {
            size.addEventListener("click", function (this: HTMLElement) {
                // Reset WooCommerce form first
                const resetButton = document.querySelector('.reset_variations') as HTMLAnchorElement;
                if (resetButton) {
                    resetButton.click();
                    // console.log('Reset variations form');
                }

                // Get the new size
                const newSize: string | null = (this as HTMLElement).getAttribute("data-value");

                // Check if current color is available in the new size
                let keepCurrentColor: boolean = false;
                if (selectedColor && newSize) {
                    const isColorAvailableInNewSize: boolean = variations.some((variation: Variation) =>
                        variation.attributes["pa_colour"] === selectedColor &&
                        variation.attributes["pa_size"] === newSize &&
                        variation.is_in_stock &&
                        variation.is_purchasable &&
                        variation.qty > 0
                    );

                    if (isColorAvailableInNewSize) {
                        keepCurrentColor = true;
                        // console.log(`Keeping current color '${selectedColor}' as it's available in size '${newSize}'`);
                    }
                }

                // Only reset color if we're not keeping the current one
                if (!keepCurrentColor) {
                    selectedColor = null;
                    document.querySelectorAll('.colour-swatch__border-wrapper').forEach(colour => colour.classList.remove('active'));
                    // Clear the color name display
                    if(colourName) {
                        colourName.textContent = '';
                    }
                }

                removeSelectedSize();
                selectedSize = newSize;

                this.classList.add('active');

                if(hasSize && hasColour) {
                    checkStock();
                } else if(hasSize) {
                    checkStockColourNoSize();
                } else if(hasColour) {
                    checkStockSizeNoColour();
                }
                updateVariationId();
                updateWooCommerceDropdowns();

                // Force re-check because the dropdown will have changed again.
                if(hasSize && hasColour) {
                    checkStock();
                } else if(hasSize) {
                    checkStockColourNoSize();
                } else if(hasColour) {
                    checkStockSizeNoColour();
                }
            });
        });

        if(hasSize !== hasColour) {
            checkStockSizeNoColour();
            checkStockColourNoSize();
        }
    }
}
